import { RouteObject } from "react-router-dom";

import { AuthorizedRoute } from "src/authentication/AuthorizedRoute.tsx";
import { Scope, ScopeResource } from "src/authentication/PermissionsProvider.tsx";
import { useT } from "src/internationalization";
import CaseDetailsPageMockDev from "src/pages/CaseDetalis/CaseDetailsPageMockDev.tsx";

import ErrorBoundary from "../components/Errors/ErrorBoundary";

/**
 * Routes réservées au développement (test UI avec mocks Apollo).
 */
export const useDevRoutes = (): RouteObject[] => {
  const t = useT();

  if (!import.meta.env.DEV) {
    return [];
  }

  return [
    {
      path: "dev/case-mock/:caseTypeCode/:id",
      element: (
        <AuthorizedRoute
          requiredPermissions={[{ resource: ScopeResource.CASE, scopes: [Scope.VIEW] }]}
          pageTitle={t("page.cases.title")}
        >
          <CaseDetailsPageMockDev />
        </AuthorizedRoute>
      ),
      ErrorBoundary: ErrorBoundary,
    },
  ];
};
